import React from 'react'

import { Form, Col } from '_zari/core'

const CondicionFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='CONDICION' htmlFor='readonly-condicion' sm={4} alignRightAt='sm' />
      <Col sm={8}>
        <Form.InputText id='readonly-condicion' name='readonly-condicion' disabled value={iValue} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CondicionFormGroup)
